module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-crud-category-hierarchy-select"
  }, [_c('el-select', {
    attrs: {
      "value": _vm.parentID,
      "placeholder": "Please select a category",
      "loading": _vm.loading
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.remoteValues), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe1fa2e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/CategoryHierarchySelect.vue
// module id = 554
// module chunks = 1